import axios from "../axiosInstance";
import type { GetLibraryModuleResponse } from "@/modules/learningCenter/features/ModuleLibrary/types/libraryModule.types";

/**
 * Fetch a single library module by ID
 */
export const fetchLibraryModuleById = async (
  id: number,
  options: { includeContentBlocks?: boolean; includeUsage?: boolean } = {}
): Promise<GetLibraryModuleResponse> => {
  const { includeContentBlocks = true, includeUsage = false } = options;

  const queryParams = new URLSearchParams();
  queryParams.append("include_content_blocks", includeContentBlocks.toString());
  queryParams.append("include_usage", includeUsage.toString());

  const response = await axios.get<GetLibraryModuleResponse>(
    `/api/learning-center/module-library/${id}?${queryParams.toString()}`
  );
  return response.data;
};

export default fetchLibraryModuleById;
